import { Injectable } from '@angular/core';
import { base64ToArrayBuffer } from '../utils/encoding';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  /**
   * Converts a base64-encoded string to a Uint8Array.
   * @deprecated Use `base64ToArrayBuffer` from `@app/utils/encoding` directly instead.
   */
  public base64ToArrayBuffer(base64: string): Uint8Array {
    return base64ToArrayBuffer(base64);
  }
}
